export default ({...props}) => {
  const {space, size} = props.theme
  return `
        padding: ${space(0.375)}px;
        [ap_atom_name="svgIconAtom"]{
          width: ${size(2.25)}px;
          height: ${size(3.2)}px;
          display: -webkit-box;
          > svg {
            width: ${size(12.5)}%;
          }
        }
        
        [ap_type="edit"]{
          width: ${size(2)}px;
          height: ${size(2)}px;
        }
    `
}
